import Facturas from "./Facturas";
import { withRouter } from "react-router-dom";

export default withRouter(Facturas);
